import React, {useEffect, useState} from 'react';
import {Paper, TablePagination, LinearProgress} from '@material-ui/core';
import {coreStyle} from "../../../styles/config";
import {parseQueryParams} from "../../../utils/helpers";
import Resource from "../../../crud/resource";
import Edit from "./add";
import Swal from "sweetalert2";
import TableList from "./tableList";
import {useSelector} from "react-redux";
import Translate from "../../../utils/utils";

const headCells = [
    {id: 'name', label: <Translate id={"TABLE.NAME"}/>},
    {id: 'actions', label: <Translate id={"TABLE.ACTIONS"}/>},
];

export default function Translation(props) {
    const {location: {search}, history, moduleName} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;
    const [moduleItems, setModuleItems] = useState([]);
    const [moduleItem, setModuleItem] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [languages, setLanguages] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: perPage,
    });
    const user = useSelector(store => store.auth.user);

    const removeItemInListing = (id) => {
        const remaining = moduleItems.filter(item => item.id !== id);
        const total = remaining.length;
        setPagination(Object.assign(pagination, {total: pagination.total - 1, 'to': total}));
        setModuleItems(remaining);
    };

    const shouldDeleteOrCreate = () => {
        const moduleNames = ['category', 'group', 'reportScore'];
        return moduleNames.indexOf(moduleName) === -1;
    }

    useEffect(() => {
        const list = () => {
            const languageResource = new Resource('language');
            const resource = new Resource(moduleName);
            setIsLoading(true);
            const requests = [
                resource.index({perPage, page}),
                languageResource.index(),
            ];

            Promise.all(requests).then(([moduleResponse, languageResponse]) => {
                const paginationData = moduleResponse.data.data;
                setModuleItems(paginationData.data);
                setPagination(paginationData);
                const languages = languageResponse.data.data.data;
                setLanguages(languages.reverse());
                setIsLoading(false);

            }).catch(error => {
                setIsLoading(false);
                Swal.fire({
                    icon: 'error',
                    text: 'An error occurred!'
                });
            });
        }
        list()
    }, [page, perPage, moduleName]);

    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`/settings/${moduleName}?page=${page}&perPage=${perPage}`);
    };

    const handlePerPageChange = (perPage) => {
        return history.push(`/settings/${moduleName}?page=${page}&perPage=${perPage}`);
    };

    const handleCreate = (moduleItem) => {
        setModuleItems([moduleItem, ...moduleItems]);
    };

    const handleUpdate = (translations, code) => {
        const moduleItemsList = moduleItems.map(item => {
            translations.forEach(translation => {
                if (moduleItem.id === item.id) {
                    if (user?.language_id === parseInt(translation.language_id)) {
                        item.name = translation.name;
                    }
                    item.code = code || item.code;
                }
            });
            return item;
        });
        setModuleItems(moduleItemsList);
    };

    return (
        <div className={coreStyle.root}>
            <div className="add-user__button">
                <Edit handleCreate={handleCreate} handleUpdate={handleUpdate} onCloseModal={() => setModuleItem({})}
                      color={moduleItem} key={moduleItem.id} languages={languages} moduleName={moduleName}
                      moduleItem={moduleItem} shouldDeleteOrCreate={shouldDeleteOrCreate}/>
            </div>

            {isLoading && <LinearProgress color="secondary"/>}
            <Paper className={coreStyle.paper}>
                <TableList moduleItems={moduleItems} onEditClicked={setModuleItem} moduleName={moduleName}
                           removeItemInListing={removeItemInListing} headCells={headCells} isLoading={isLoading}
                           shouldDeleteOrCreate={shouldDeleteOrCreate}
                />
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]}
                    labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
